<template>
  <transition name="fade">
    <div v-if="isShow" class="right-panel" @click.stop="">
      <div class="right-header">
        <slot name="header">
          title
        </slot>
        <div class="close-btn" @click="onClose()">
          <i class="material-icons" translate>clear</i>
        </div>
      </div>
      <div class="content">
        <slot name="content">
          <el-form class="profile-form"
                   :model="profileModel"
                   :rules="rules"
                   ref="profileForm">

            <el-form-item v-for="(val,key) in formItems" :label="val.label" :labelWidth="val.labelWidth" :key="key">
              <el-col :span="item.col" :class="item.class" v-for="(item,key) in val.childs" :key="key">
                <el-form-item :prop="item.key">
                  <el-upload class="uploader-wrapper" v-if="item.type === 'uploader'"
                             :action="item.option.action"
                             :show-file-list="false"
                             :data="item.option.data"
                             :before-upload="item.option.onBeforeUpload"
                             :on-success="item.option.onSuccess"
                             :on-error="item.option.onFail"
                             :on-progress="item.option.onProgress"
                             :on-change="item.option.onChange"
                             :multiple="false">
                    <img v-if="profileModel[item.key]"
                         :src="profileModel[item.key]"
                         class="avatar">
                    <i v-else class='el-icon-upload avatar-uploader-icon'></i>
                    <div>上传新头像</div>
                  </el-upload>

                  <el-select v-else-if="item.type === 'select'" v-model="profileModel[item.key]">
                    <el-option
                        v-for="(item,index) in item.options"
                        :label="item.text"
                        :value="item.key"
                        class="sns-item"
                        :key="index"
                    >
                    <span v-if="item.icon" class="pull-left">
                      <i :class="item.icon"></i>
                    </span>
                      <span v-if="item.logo" class="pull-left">
                      <img :src="item.logo" class="sns-logo" border="0"/>
                    </span>
                      <span v-if="item.icon">
                      <i class="material-icons pull-left">{{item.icon}}</i>
                    </span>
                      <span>{{ item.text }}</span>
                    </el-option>
                  </el-select>

                  <el-select v-else-if="item.type === 'level'" v-model="profileModel[item.key]">
                    <el-option v-for="(perItem,index) in item.options" :label="perItem.label" :value="perItem.key" :key="index">
                      <el-rate
                          disabled
                          v-model="perItem.val"
                          :text-template="perItem.label"
                          :show-text="true">
                      </el-rate>
                    </el-option>

                  </el-select>

                  <el-radio-group v-else-if="item.type === 'radio'" v-model="profileModel[item.key]">
                    <el-radio v-for="(option,key) in item.options" :label="option.label" :key="key">{{option.text}}</el-radio>
                  </el-radio-group>

                  <el-date-picker  v-else-if="item.type === 'datePicker'" :type="item.pickerType"
                                   :placeholder="item.placeholder"
                                   v-model="profileModel[item.key]"
                  >
                  </el-date-picker>

                  <span class="line" v-else-if="item.type === 'separation'">&nbsp;{{item.text}}&nbsp;</span>

                  <span class="line" style="display:block; margin-left: 130px; margin-top: -12px; color: #999; font-size: 12px;" v-else-if="item.type === 'tips'">{{item.text}}</span>

                  <el-checkbox v-else-if="item.type === 'check'" v-model="profileModel[item.key]" @change="item.checkFun(profileModel[item.key])">{{item.label}}</el-checkbox>

                  <el-input class="right-panel-textarea" v-else-if="item.type === 'textarea'" type="textarea" :autosize="item.options.autosize" :resize="item.options.resize" v-model="profileModel[item.key]"></el-input>

                  <el-input v-else v-model.trim="profileModel[item.key]" :disabled="item.disabled"></el-input>

                </el-form-item>
              </el-col>
            </el-form-item>
          </el-form>
        </slot>
      </div>
      <div class="footer" v-if="!hideFooter">
        <slot name="footer">
          <el-button type="primary" @click="onSubmit('profileForm')" :loading="submiting"><translate>Save</translate></el-button>
          <el-button  @click="onClose()"><translate>Cancel</translate></el-button>
        </slot>
      </div>
    </div>
  </transition>
</template>
<script>
 /* eslint-disable */
 import $ from 'jquery'
 export default {
   name: 'RightPanel',
   props: {
     items:{
       type:Object,
       required: false,
     },
     hideFooter:{
       type: Boolean,
       required: false
     },
     datas:{
       required: false
     }
   },
   data() {
     const formData = this.initFormData()
     return {
       isShow: false,
       submiting: false,
       rules: formData.rules,
       profileModel: formData.profileModel,
       formItems: formData.formItems
     };
   },
   computed:{
   },
   mounted () {
     if (this.datas) {
       this.isShow = true
     } else {
       this.isShow = false
     }
   },
   methods: {
     initFormData () {
       let rules = {},profileModel = {},formItems = {}
       if (!!this.items) {
         Object.forEach(this.items, function(val,key) {
           if(val.label){
             val.labelWidth = '130px'
           }
           formItems[key] = val
           if (!val.childs) {
             val.key= key
             formItems[key].childs = [val]
           }
           formItems[key].childs.forEach(function(child, index){
             if(child.key){
               profileModel[child.key] = child.val
               if(child.rule) {
                 rules[child.key] = child.rule
                 delete child.rule
               }
             }
           });
         });
       }
       return{
         rules:rules,
         profileModel:profileModel,
         formItems:formItems
       }
     },

     validate(){
       const that = this;
       return new Promise(function (resolve, reject) {
         that.$refs['profileForm'].validate((valid) => {
           if (valid) {
             resolve()
           }else{
             reject()
           }
         });
       })
     },
     onSubmit(formName){
       this.validate().then(()=>{
         this.submiting = true;
         this.$emit('onSubmit', formName);
       },()=>{});
     },
     onSubmitErr () {
       this.submiting = false;
     },
     onClose(){
       this.isShow = false
       $('body').unbind('click')
       $('.el-dialog__wrapper').unbind('click')
//       $(this.$el).css('right', $(this.$el).width() > 430 ? '-30%' : '-430px').removeClass('opened')
       window.setTimeout(()=> {
         $('body').css('overflow-y','auto')
         this.$emit('onClose')
       }, 300)
     },
     resetForm (formName) {
       this.$refs[formName].resetFields();
     },
     onShow(){
       this.isShow = true
      //  $('body').css('overflow-y','hidden');
       $('body').bind('click',() => {
         this.onClose()
       })
//       $('.instance-dialog').click((event) => {
//         event.stopPropagation()
//       })
       $('.el-dialog__wrapper').click((event) => {
         event.stopPropagation()
       })
     }
   },
   watch:{
     'datas': {
       handler () {
         console.log('watch datas:', this.datas)
         if (this.datas) {
           this.onShow()
         } else {
           this.isShow = false
         }
       },
       deep: true
     },
     'items':{
       handler () {
         const formData = this.initFormData()
         this.rules = Object.assign({},this.rules,formData.rules)
         this.profileModel = Object.assign({},this.profileModel,formData.profileModel)
         this.formItems = Object.assign({},this.formItems,formData.formItems)
       },
       deep:true
     }
   }
 };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  rel="stylesheet/scss" lang="scss">
 .right-panel{
  position: fixed;
  top: 0px;
  right: -0%;
  width: 30%;
  min-width: 530px;
  bottom: 0;
  background: #FFF;
  box-shadow: -2px 0px 5px #ccc;
  z-index: 8;
  padding: 0px 15px 60px 15px;
  border-left: 1px solid #ddd;
  &.opened{
    right: 0;
  }
  .right-header{
    height: 60px;
    line-height: 60px;
    border-bottom: 1px solid #ddd;
    padding: 0 15px;
    background: #EFF3F4;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
   .profile-form{
     padding: 15px;
   }
  .content{
    overflow-y: auto;
    // padding: 75px 0;
    position: absolute;
    top: 60px;
    bottom: 60px;
    left: 0;
    // padding: 15px;
    width: 100%;
  }
  .footer {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    line-height: 60px;
    height: 60px;
    border-top: 1px solid #ddd;
    text-align: center;
    .el-button--default {
      min-width: 120px;
    }
    .el-button--primary{
      min-width: 120px;
    }
  }
  .close-btn{
    position: absolute;
    right: 8px;
    top: 8px;
    cursor: pointer;
  }
 }
 .col-label {
  font-size: 11px;
  color: #CDD7D5;
 }

 .col-val {
  font-size: 18px;
 }

 .uploader-wrapper {
  width: 200px;
  height: 200px;
  background: #707070;
  border: 0px solid #707070;
  border-radius: 2px;
  text-align: center;
  color: #FFF;
  img{
   width: 200px;
   height: 200px;
  }
 }

 .uploader {
  background: rgba(0, 0, 0, 0.56);
  text-align: center;
 }

 .el-icon-upload {
  font-size: 44px;
  color: #fff;
  margin-top: 45px;
 }
 .ql-toolbar.ql-snow{
  padding: 0;
 }
 .ql-formats{
  line-height: 24px;
 }
 .ql-container.ql-snow .ql-editor{
  min-height: 150px;
 }

 .profile-form{
  label.el-form-item__label{
   padding: 11px 30px 11px 0;
  }
  .el-date-editor.el-input{
   width: 100%;
  }
 }
  .el-select {
    width: 100%;
  }

 .fade-enter-active, .fade-leave-active {
   transition: right .3s
 }
 .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
   right: -100%
 }
 .right-panel-textarea{
   .el-textarea__inner{
     height: 200px !important;
   }
 }
</style>



// WEBPACK FOOTER //
// right-panel.vue?a814f212